'use client';

import Link from 'next/link';

import {
  MAIL_CONFIG,
  PRIMARY_PHONE_NUMBER_BY_DOMAIN_AND_LOCALE_CONFIG,
} from '../constants';
import { ContactsCommonProps } from './types';

import { Locale } from '@/shared/types';
import { getDomainKey } from '@/shared/utils/getDomainInfo';

export const PhoneNumberBlock = ({
  clientHost,
  locale,
}: ContactsCommonProps & { locale: Locale }) => {
  const phoneNumber =
    PRIMARY_PHONE_NUMBER_BY_DOMAIN_AND_LOCALE_CONFIG[getDomainKey(clientHost)][
      locale
    ];

  if (phoneNumber) {
    return (
      <Link
        href={`tel:${phoneNumber?.href}`}
        className="text-[20px] leading-[32px]"
        aria-label={phoneNumber?.label}
      >
        {phoneNumber?.label}
      </Link>
    );
  }

  const email = MAIL_CONFIG[getDomainKey(clientHost)];

  return (
    <Link
      href={`mailto:${email}`}
      className="text-[20px] leading-[32px]"
      aria-label={email}
    >
      {email}
    </Link>
  );
};
